<section class="pt-16 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Spettacoli', route: '/backoffice/spettacoli/' }, { label: (spettacolo?.spettacolo), active: true }]"></app-breadcrumb-backoffice>
</section>

<section class="px-container pb-4">
    <div class="ac-main-tabs" role="tablist">
        <button type="button" class="ac-main-tab" [class.active]="section === 'info'" (click)="section = 'info'">Info</button>
        <button type="button" class="ac-main-tab" [class.active]="section === 'calendario'" (click)="section = 'calendario'">Calendario</button>
        <button type="button" class="ac-main-tab" [class.active]="section === 'cast'" (click)="section = 'cast'">Cast</button>
        <button type="button" class="ac-main-tab" [class.active]="section === 'prezzi'" (click)="section = 'prezzi'">Prezzi</button>
        <button type="button" class="ac-main-tab" [class.active]="section === 'timeline'" (click)="section = 'timeline'">Timeline</button>
        <button type="button" class="ac-main-tab" [class.active]="section === 'immagini'" (click)="section = 'immagini'">Immagini</button>
        <button type="button" class="ac-main-tab" [class.active]="section === 'gallery'" (click)="section = 'gallery'">Gallery</button>
    </div>
</section>

<section class="px-container pb-16">
    <form [formGroup]="formSpettacolo" class="accrediti-form spettacolo-form flex flex-col gap-6" (ngSubmit)="onSubmit()">

        @if (section == 'info') {
            <div class="ac-section-head">
                <h2>Info</h2>
                <span class="ac-meta">dati principali dello spettacolo</span>
            </div>

            <div class="flex lg:flex-row flex-col gap-4">
                <div class="fld flex-1">
                    <label>* Spettacolo</label>
                    <input type="text" pInputText class="w-full" placeholder="Spettacolo" formControlName="spettacolo" required />
                    @if (formSpettacolo.get('spettacolo')?.hasError('required') && (formSpettacolo.get('spettacolo')?.dirty || formSpettacolo.get('spettacolo')?.touched)) {
                        <small class="text-red-600 block mt-2 font-medium">Lo spettacolo è obbligatorio.</small>
                    }
                </div>
                <div class="fld flex-1">
                    <label>Compagnia</label>
                    <input type="text" pInputText class="w-full" placeholder="Compagnia" formControlName="compagnia" />
                </div>
            </div>

            <div class="fld">
                <label>Descrizione</label>
                <p-editor [style]="{ height: '150px' }" formControlName="descrizione" />
            </div>

            <div class="fld">
                <label>* Data</label>
                <p-calendar formControlName="dal_al" placeholder="Data Dal - Al" dateFormat="dd/mm/yy" [showIcon]="true" selectionMode="range" styleClass="w-full" appendTo="body" />
                @if (formSpettacolo.get('dal_al')?.hasError('required') && (formSpettacolo.get('dal_al')?.dirty || formSpettacolo.get('dal_al')?.touched)) {
                    <small class="text-red-600 block mt-2 font-medium">Inserire una data valida</small>
                }
            </div>

            <div class="flex lg:flex-row flex-col gap-4">
                <div class="fld flex-1">
                    <label>Vendita Dal</label>
                    <p-calendar formControlName="prenotabile_dal" placeholder="Vendita Dal" dateFormat="dd/mm/yy" [showIcon]="true" styleClass="w-full" appendTo="body" />
                    @if (!formSpettacolo.get('prenotabile_dal')?.valid && formSpettacolo.get('prenotabile_dal')?.touched) {
                        <small class="text-red-600 block mt-2 font-medium">Inserire una data valida</small>
                    }
                </div>
                <div class="fld flex-1">
                    <label>Orario Vendita Dal</label>
                    <p-calendar placeholder="Orario Vendita Dal" formControlName="prenotabile_dal_orario" [timeOnly]="true" [showIcon]="true" styleClass="w-full" appendTo="body" />
                </div>
            </div>

            <div class="ac-section-head mt-4">
                <h2>Impostazioni</h2>
                <span class="ac-meta">visibilità e stato vendita</span>
            </div>

            <div class="sp-checks-grid">
                <div class="sp-checks-col">
                    <p-checkbox label="Online" formControlName="online" value="online" pTooltip="Se selezionato, lo spettacolo sarà visibile ai clienti!" tooltipPosition="top" />
                    <p-checkbox label="Evidenzia" formControlName="evidenzia" value="evidenzia" pTooltip="Se selezionato, lo spettacolo apparirà in home. Un video o un'immagine della galleria marcati 'in evidenza' sostituiscono la copertina." tooltipPosition="top" />
                    <p-checkbox label="Gratuito" formControlName="gratuito" value="gratuito" pTooltip="Se selezionato, il pulsante di acquisto delle spettacolo apparirà con il testo 'PRENOTA SUBITO'" tooltipPosition="top" />
                </div>
                <div class="sp-checks-col">
                    <p-checkbox label="In vendita dal" formControlName="in_vendita_dal" value="in_vendita_dal" (ngModelChange)="onInVenditaDal($event)" pTooltip="Se selezionato, il pulsante di acquisto delle spettacolo apparirà con il testo 'IN VENDITA DAL + DATA INSERITA' e non sarà cliccabile" tooltipPosition="top" />
                    @if (formSpettacolo.get('in_vendita_dal')?.value && formSpettacolo.get('in_vendita_dal')?.value.length > 0) {
                        <div class="fld">
                            <label>* Data in vendita dal</label>
                            <p-calendar formControlName="in_vendita_dal_data" placeholder="Data in vendita dal" dateFormat="dd/mm/yy" [showIcon]="true" styleClass="w-full" appendTo="body" />
                            @if (formSpettacolo.get('in_vendita_dal_data')?.hasError('required') && (formSpettacolo.get('in_vendita_dal_data')?.dirty || formSpettacolo.get('in_vendita_dal_data')?.touched)) {
                                <small class="text-red-600 block mt-2 font-medium">Inserire una data valida</small>
                            }
                        </div>
                    }
                    <p-checkbox label="A breve in vendita" formControlName="soon_in_vendita" value="soon_in_vendita" pTooltip="Se selezionato, il pulsante di acquisto delle spettacolo apparirà con il testo 'A BREVE IN VENDITA' e non sarà cliccabile" tooltipPosition="top" />
                    <p-checkbox label="Sold Out" formControlName="sold_out" value="sold_out" pTooltip="Se selezionato, il pulsante di acquisto delle spettacolo apparirà con il testo 'SOLD OUT' e non sarà cliccabile" tooltipPosition="top" />
                    <p-checkbox label="Annullato" formControlName="annullato" value="annullato" pTooltip="Se selezionato, il pulsante di acquisto delle spettacolo apparirà con il testo 'ANNULLATO' e non sarà cliccabile" tooltipPosition="top" />
                </div>
                <div class="sp-checks-col">
                    <p-checkbox label="Web Shop" formControlName="webshop" value="webshop" (ngModelChange)="onCheckBox($event, 'webshop')" pTooltip="Se selezionato, al pulsante d'acquisto verrà associato il link inserito nel campo 'Link Webshop'" tooltipPosition="top" />
                    <p-checkbox label="Custom" formControlName="custom" value="custom" (ngModelChange)="onCheckBox($event, 'custom')" pTooltip="Se selezionato, al pulsante d'acquisto verrà associato il link inserito nel campo 'Link Custom'" tooltipPosition="top" />
                </div>
            </div>

            @if (webshop) {
                <div class="ac-section-head mt-2"><h2>Web shop</h2></div>
                <div class="fld">
                    <label>Link Web Shop</label>
                    <input type="text" pInputText class="w-full" formControlName="link_webshop" />
                </div>
            }

            @if (custom) {
                <div class="ac-section-head mt-2"><h2>Custom</h2></div>
                <div class="fld">
                    <label>Link Custom</label>
                    <input type="text" pInputText class="w-full" formControlName="link_custom" />
                </div>
            }

            <div class="ac-section-head mt-2">
                <h2>Spettacoli suggeriti</h2>
                <span class="ac-meta">solo 3 selezionabili</span>
            </div>
            @if (!carica) {
                <div class="fld">
                    <label>Seleziona</label>
                    <p-multiSelect
                        [options]="spettacoli"
                        formControlName="spettacoli_suggeriti"
                        placeholder="Seleziona gli spettacoli"
                        optionLabel="spettacolo"
                        display="chip"
                        [maxSelectedLabels]="3"
                        [maxlength]="3"
                        [showToggleAll]="false"
                        [showClear]="true"
                        styleClass="w-full"
                        appendTo="body"
                    />
                    @if (formSpettacolo.get('spettacoli_suggeriti')?.hasError('maxlength') && (formSpettacolo.get('spettacoli_suggeriti')?.dirty || formSpettacolo.get('spettacoli_suggeriti')?.touched)) {
                        <small class="text-red-600 block mt-2 font-medium">Selezionare solo 3 spettacoli.</small>
                    }
                </div>
            }
        }

        @if (section == 'calendario') {
            <div class="ac-section-head"><h2>Calendario</h2></div>
            <app-calendario-spettacolo-backoffice [date_calendario]="date_calendario" (data)="onDateSpettacolo($event)"></app-calendario-spettacolo-backoffice>
        }

        @if (section == 'cast') {
            <div class="ac-section-head"><h2>Cast</h2></div>
            <app-cast-spettacolo-backoffice [casts]="casts" (data)="onCastSpettacolo($event)"></app-cast-spettacolo-backoffice>
        }

        @if (section == 'prezzi') {
            <div class="ac-section-head"><h2>Prezzi</h2></div>
            <app-prezzi-spettacolo-backoffice [prezzi]="prezzi" (data)="onPrezziSpettacolo($event)"></app-prezzi-spettacolo-backoffice>
            <div class="fld">
                <label>Descrizione</label>
                <p-editor [style]="{ height: '150px' }" formControlName="descrizione_prezzi" />
            </div>
        }

        @if (section == 'timeline') {
            <div class="ac-section-head"><h2>Timeline</h2></div>
            <app-timeline-spettacolo-backoffice [spettacolo]="spettacolo" [timelines]="timelines" (data)="onTimelineSpettacolo($event)"></app-timeline-spettacolo-backoffice>
        }

        @if (section == 'immagini') {
            <div class="ac-section-head"><h2>Immagini</h2></div>
            <app-immagini-spettacolo-backoffice [spettacolo]="spettacolo" (ritaglio)="onImmaginiSpettacolo($event)"></app-immagini-spettacolo-backoffice>
        }

        @if (section == 'gallery') {
            <div class="ac-section-head"><h2>Gallery</h2></div>
            <app-galleria-spettacolo-backoffice [spettacolo]="spettacolo" [galleria]="galleria" (data)="onGalleriaSpettacolo($event)"></app-galleria-spettacolo-backoffice>
        }

        <div class="acc-actions mt-4">
            <button class="acc-btn acc-btn-ghost" type="button" (click)="onOpenDeleteSpettacolo($event)">Elimina spettacolo</button>
            <button class="acc-btn acc-btn-primary" type="submit" [disabled]="!formSpettacolo.valid || loading">
                @if (loading) {
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="animate-spin w-4 inline me-2 fill-current"><path d="M222.7 32.1c5 16.9-4.6 34.8-21.5 39.8C121.8 95.6 64 169.1 64 256c0 106 86 192 192 192s192-86 192-192c0-86.9-57.8-160.4-137.1-184.1c-16.9-5-26.6-22.9-21.5-39.8s22.9-26.6 39.8-21.5C434.9 42.1 512 140 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 140 77.1 42.1 182.9 10.6c16.9-5 34.8 4.6 39.8 21.5z"/></svg>
                }
                Salva modifiche
            </button>
        </div>

        <p-confirmPopup #deleteSpettacolo>
            <ng-template pTemplate="headless" let-message>
                <div class="border-round p-3">
                    <span class="text-base">{{ message.message }}</span>
                    <div class="flex align-items-center gap-2 mt-3">
                        <button type="button" class="acc-btn flex-1" (click)="onDeleteSpettacolo()">Elimina</button>
                        <button type="button" class="acc-btn acc-btn-ghost flex-1" (click)="onAnnullaDeleteSpettacolo()">Annulla</button>
                    </div>
                </div>
            </ng-template>
        </p-confirmPopup>
    </form>
</section>
